export default function printReportSquareMeter(name, id, showProductUnit = false) {
  const token = localStorage.getItem("token");
  const reports = {
    simple: () => simple(id, token, showProductUnit),
    rooms: () => rooms(id, token, showProductUnit),
    deliveryManifest: () => deliveryManifest(id, token),
    contrato: () => reportContrato(id, token),
    duasVias: () => reportSimplesDuasVias(id, token, showProductUnit),
    contractEditable: () => printContractEditable(id, token),
  }

  reports[name]()
}

function simple(id, token, showProductUnit) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales-square-meter/gerar/relatorio/${id}?auth=${token}&showProductUnit=${showProductUnit}`
  );
}

function rooms(id, token, showProductUnit) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales-square-meter/gerar/relatorio/ambiente/${id}?auth=${token}&showProductUnit=${showProductUnit}`
  );
}
function reportSimplesDuasVias (id, token, showProductUnit) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales-square-meter/gerar/relatorio/padrao/duasVias/${id}?auth=${token}&showProductUnit=${showProductUnit}`
  );
}
function deliveryManifest(id, token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales-square-meter/gerar/relatorio/entrega/itens/${id}?auth=${token}`
  );
}

function reportContrato (id, token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales-square-meter/gerar/contrato/${id}?auth=${token}`
  );
}

function printContractEditable(id, token) {
  window.open(
    `${process.env.VUE_APP_URL_BACKEND}/sales-square-meter/print/contract/editable/${id}?auth=${token}`
  );
}
